import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";

import React from "react";
import EquityFundTabs from "./EquityFundTabs";
import MoneyMarketFundTabs from "./MoneyMarketFundTabs";

export default function MoneyMarketFund() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  pb-10">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-4xl font-bold tracking-tight">Money Market Fund</h3>
            <p className="mt-6 text-base max-w-lg leading-7 ">
            Do you have a dream or goal you wish to achieve within a certain timeframe? The Britam Money Market fund will help you plan your financial goals whether it be setting up an emergency fund, saving for school fees, or saving up for a business project. With the fund, you get to earn between 8-10%* in interest as you build your savings.
            </p>
            <p className="mt-6  text-base  max-w-lg leading-7 ">
            So, what is a Money Market Fund? This is a type of unit trust fund that invests in low-risk investments with an element of stable returns such as fixed deposit accounts, treasury bills or in a commercial bond. A money market fund invests mainly in fixed income securities with short investment duration and high credit quality.
            </p>

            <div className="mt-10 flex items-center gap-x-4">
              <a
                href="#"
                className="mt-10 block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Application Form
              </a>
            </div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-xl pt-24 lg:flex-shrink-0">
            <MoneyMarketFundTabs />
          </div>
        </div>
      </div>
    </div>
  );
}
